import React, { useRef } from "react";
import { Column } from "@ant-design/plots";
import { Card } from "antd";
import { FiFileText } from "react-icons/fi";

const UtilStackGraph = ({ utilsByBUCount, buId, selectTeam }) => {
  const processedData = (() => {
    if (!utilsByBUCount || !Array.isArray(utilsByBUCount)) {
      return [];
    }

    return utilsByBUCount.flatMap((teamData) => {
      const clientCount = parseInt(teamData.clientCount, 10) || 0;
      const internalCount = parseInt(teamData.internalCount, 10) || 0;
      const onBenchCount = parseInt(teamData.notWorkingCount, 10) || 0;
      const total = parseInt(clientCount + internalCount + onBenchCount);
      let ratio = 0;
      if (total > 0) {
        let ratioValue = (clientCount + internalCount) / total * 100;
        let decimalPart = ratioValue - Math.floor(ratioValue);
        
        ratio = decimalPart >= 0.5 ? Math.ceil(ratioValue) + "%" : ratioValue.toFixed(1) + "%";
        ratio = parseFloat(ratio) + "%";
      }

      return [
        {
          Name: teamData.team,
          Type: "Client Project",
          Value: clientCount,
          Ratio: "",
        },
        {
          Name: teamData.team,
          Type: "Internal Project",
          Value: internalCount,
          Ratio: "",
        },
        {
          Name: teamData.team,
          Type: "On Bench",
          Value: onBenchCount,
          Ratio: ratio,
        },
      ];
    });
  })();

  const chartRef = useRef(null);
  const rotatelabel = (datum, ranking, name) => {
    const { chart } = chartRef.current;
    const { document } = chart.getContext().canvas;

    const group = document?.createElement("g", {});

    const text =
      name[ranking].length > 10
        ? `${name[ranking].substring(0, 8)}...`
        : name[ranking];

    const label = document.createElement("text", {
      style: {
        text,
        fontSize: 12,
        fill: "#9B9DA0",
        textAlign: "center",

        transform: `translate(0, 25) rotate(-45deg)`,
      },
    });

    group.appendChild(label);
    return group;
  };

  const config = {
    data: processedData,
    stack: true,
    xField: "Name",
    yField: "Value",
    colorField: "Type",
    label: [
      {
        text: "Ratio",
        textBaseline: "bottom",
        position: "top",
        rotate: 45,
      },
    ],
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
    yAxis: {
      label: {
        formatter: (v) => `${v}`,
      },
    },
    axis: {
      x: {
        size: 40,
        labelFormatter: (datum, index, text) => rotatelabel(datum, index, text),
        grid: true,
        gridLineWidth: 2,
      },

      y: { grid: true, gridLineWidth: 2 },
    },
    grid: {
      line: {
        style: {
          stroke: "#E7E7E7",
          lineDash: [4, 4],
        },
      },
    },
    legend: {
      color: {
        title: false,
        position: "bottom",
        rowPadding: 5,
        layout: {
          margin: 10,
        },
      },
    },
    height: 300,
    scale: {
      x: { padding: 0.5 },
    },
    columnWidthRatio: 0.6,
    onReady: ({ chart }) => {
      chartRef.current = { chart };
    },
  };

  return (
    <Card style={{ border: "1px solid #0000001F", borderRadius: "16px" }}>
      <div
        style={{
          fontWeight: "700",
          fontSize: "16px",
          padding: "0px 8px 4px 8px",
        }}
      >
        {(selectTeam || buId) === "SPAN-BLR-0001" ? "BU Utilization" : "Team Utilization"}
      </div>
      {utilsByBUCount.length == 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            height: "305px",
            color: "#9B9DA0",
            fontWeight: "700",
          }}
        >
          <span>
            <FiFileText style={{ fontSize: "60px" }} />
          </span>
          <span>No data available</span>
        </div>
      ) : (
        <Column {...config} />
      )}
    </Card>
  );
};

export default UtilStackGraph;
